export const WEBEX_TAB_ID = 'integrations-ui-webex-login-tab';

/**
 * @see http://www.xtf.dk/2011/08/center-new-popup-window-even-on.html
 *
 * Tested with popup size:
 *    width: 1000px
 *    height: 600px
 */
export const popupCenter = (url: string, title: string, width = 1000, height = 600) => {
  // Fixes dual-screen position                         Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : (window.screen as any).left;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : (window.screen as any).top;

  const popupWidth = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth
    ? document.documentElement.clientWidth
    : (window.screen as any).width;
  const popupHeight = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight
    ? document.documentElement.clientHeight
    : (window.screen as any).height;

  const left = popupWidth / 2 - width / 2 + dualScreenLeft;
  const top = popupHeight / 2 - height / 2 + dualScreenTop;

  return window.open(
    url,
    title,
    `popup=yes, toolbar=no, location=no, directories=no, status=no, menubar=no, resizable=no, copyhistory=no, scrollbars=yes, width=${width}, height=${height}, top=${top}, left=${left}`
  );
};
